<template>
  <div>
    <v-row>
      <v-col v-for="(facetsColumn, index) in facetsToShow" :key="index" justify="space-between" style="padding: 5px;">
        <div class="facet-column" :style="{ height: columnHeight + 'px' }">
          <Breadcrumbs :facets="facetsColumn" />
          <div v-for="facet in facetsColumn" :key="facet.field" class="">
            <template v-if="!facet.hidden">
            <Checkboxs v-if="facet.component === 'checkBox'"
              :elasticSearch="facet.elasticSearchConfig"
              :field="facet.field" :title="facet.title" :items="facet.items"
              :type="facet.type" :searchable="facet.searchable" :breadcrumbTitle="facet.breadcrumbTitle"
              :show="facet.show"
              :defaultValueLabels="facet?.defaultValueLabels"
              @show-changed="() => facet.show = !facet.show"
            />
            <Radioboxs v-if="facet.component === 'radioBox'" :field="facet.field" :title="facet.title" :items="facet.items"
              :type="facet.type" :searchable="facet.searchable" :breadcrumbTitle="facet.breadcrumbTitle" />

            <Toggle v-if="facet.component === 'toggle'" :field="facet.field" :title="facet.title" :items="facet.items"
              :breadcrumbTitle="facet.breadcrumbTitle" :type="facet.type" />

            <Transport v-if="facet.component === 'transport'" :title="facet.title" :fields="facet.fields" />

            <Date
              v-if="facet.component === 'date'"
              :title="facet.title"
              :fields="facet.fields"
              :departDelta="facet.departDelta || 3"
              :is-variation-active="facet.isVariationActive"
              @change-is-variation-active="(value) => toggleVariationForDateFacet(facet.field, value)"
              :show="facet.show || false"
            />

            <Inputnumber v-if="facet.component === 'inputNumber'" :field="facet.field" :title="facet.title"
              :items="facet.items" :breadcrumbTitle="facet.breadcrumbTitle" :type="facet.type" />
              
            <RangeSlider 
              v-if="facet.component === 'rangeSlider'" 
              :show="facet.show"
              :title="facet.title"
              :items="facet.items"
              :field="facet.field"
              :type="facet.type"
              :defaultValueLabels="facet?.defaultValueLabels"
              @show-changed="() => facet.show = !facet.show"
            />

            <!-- Other cases -->
          </template>
          </div>
        </div>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import Checkboxs from "./facets/Checkboxs";
import Radioboxs from "./facets/Radioboxs";
import Toggle from "./facets/Toggle";
import Transport from "./facets/Transport";
import Date from "./facets/Date";
import Inputnumber from "./facets/Inputnumber";
import Breadcrumbs from "./Breadcrumbs";
import { getFacetsConfiguration } from '../configs/helper'
import RangeSlider from "./facets/RangeSlider";

export default {
  components: {
    Checkboxs,
    Radioboxs,
    Toggle,
    Transport,
    Date,
    Inputnumber,
    Breadcrumbs,
    RangeSlider
},
  props: {
    facetsValues: Object,
    columnHeight: {
      type: Number,
      default: 285
    }
  },
  data: () => {
    return {
      facetsConfig: getFacetsConfiguration()
    };
  },
  computed: {
    facetsToShow() {
      let facetsToShow = [];

      Object.entries(this.facetsConfig).forEach(([key, properties]) => {

        // VALIDATE CUSTOMER PERMISSIONS
        // if(properties.roles) {
        //   const isAllowed = this.$store.getters.allowAction(properties.roles)
        //   // console.log(isAllowed)
        //   if(!isAllowed) return
        // } 

        if(!properties.elasticSearch) return

        let items = []
        let baseTypeSingle = null
        const fields = []
        if(properties.multiFields) {
          properties.elasticSearch.forEach(el => {
            fields.push({
              parentField: key,
              field: el.facet,
              items: this.facetsValues?.[el.facet]?.data || [],
              label: el.label ? el.label : el.facet
            })
          })
        } else {
          properties.elasticSearch.forEach(el => {
            baseTypeSingle = el.type
            const existValues = this.facetsValues?.[el.facet]
            if(existValues && existValues.data &&  existValues.data.length) {
              items = existValues.data.map(d => {
                return {
                  id: `${el.facet}-${d.value || d.from || 'last'}`,
                  ...d
                }
              })
            }

          })
        }

        if (!facetsToShow[properties.orderInColumns]) {
            facetsToShow[properties.orderInColumns] = [];
        }

        facetsToShow[properties.orderInColumns].push({
          field: key,
          title: properties.label,
          items: items,
          fields: fields,
          elasticSearchConfig: properties.elasticSearch,
          isMultiFacet: properties.multiFields || false,
          searchable: properties.searchable,
          component: properties.component,
          type: baseTypeSingle,
          orderInPanel: properties.orderInPanel,
          breadcrumbTitle: properties.breadcrumbTitle,
          show: properties.show,
          defaultValueLabels: properties.checkboxDefaultValueLabels,
          departDelta: properties.departDelta,
          isVariationActive: !!properties.isVariationActive,
          hidden: properties.hidden ,
          fieldType: properties.fieldType          
        })
      })

      facetsToShow = facetsToShow.map(facetsColumn => facetsColumn.sort((a, b) => a.orderInPanel - b.orderInPanel));

      return facetsToShow;
    },
  },
  methods: {
    toggleVariationForDateFacet(facetField, value) {
      this.facetsConfig[facetField].isVariationActive = value;
    }
  }
};
</script>

<style lang="scss">
.facet-column {
  //height: 395px;
  min-width: 16vw;
  overflow-x: hidden;
  overflow-y: scroll;

  //Scroll bar for firefox
  scrollbar-color: #c71900 #EEEEEE;
  scrollbar-width: thin;
}

.v-expansion-panel:before {
  box-shadow: none;
}

.toggle {
  .v-messages {
    display: none;
  }
}

//* Them red checkboxes .. **/

.facet-item {
  position: relative;

  input[type="checkbox"] {
    line-height: 2.1ex;
  }

  input[type="radio"],
  input[type="checkbox"] {
    position: absolute;
    left: -999rem;
  }

  label::before {
    content: "";
    display: inline-block;
    vertical-align: -25%;
    height: 16px;
    width: 16px;
    border: 1px solid rgb(166, 166, 166);
    border-radius: 4px;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.25);
    margin-right: 0.5em;
  }
}

.facet-item--selected {
  label::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 5px;
    background: rgba(0, 0, 0, 0);
    top: 10px;
    left: 11px;
    border: 3px solid white;
    border-top: none;
    border-right: none;
    transform: rotate(-45deg);
  }

  label::before {
    content: "";
    border: 1px solid red;
    background-color: red;
  }
}

.facet-column::-webkit-scrollbar {
  width: 5px;
}

.facet-column::-webkit-scrollbar-track {
  border-radius: 100px;
  background: #EEEEEE;
}

.facet-column::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background: #c71900;
}
</style>